<section class="document-analysis-company">
  <div class="document-analysis-company__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
  </div>

  <app-analysis-page-skeleton *ngIf="isLoadingCompany"></app-analysis-page-skeleton>

  <ng-container *ngIf="!isLoadingCompany && onboardingCompanyInformation">
    <app-company-analysis-header
      [company]="onboardingCompanyInformation"
      [hasExpandedStage]="hasExpandedStage"
      (toggleAll)="toggleAllStages()">
    </app-company-analysis-header>

    <app-analysis-summary-cards [metrics]="metrics"></app-analysis-summary-cards>

    <!-- Conteúdo principal -->
    <div class="document-analysis-company__content">
      <!-- Informações da empresa -->
      <app-company-registration-card
        [onboardingCompanyInformation]="onboardingCompanyInformation"
        (saveCompanyInfo)="saveOnboarding($event)">
      </app-company-registration-card>

      <!-- Seção de documentos -->
      <div class="document-analysis-company__content__documents">
        <!-- Iteração sobre as etapas -->
        <ng-container *ngFor="let stage of onboardingCompanyInformation?.onboardingProcess?.stages">
          <app-analysis-stage-section
            *ngIf="stage.requiredDocuments.length"
            [stage]="stage"
            [stageLabel]="onboardingDocumentsTranslationService.getTranslationForStage(stage.name)"
            [metrics]="stageMetrics[stage.name]"
            [expanded]="isStageExpanded(stage.name)"
            [documentLabels]="documentLabels[stage.name]"
            [submissionTooltips]="submissionTooltips"
            [analysisTooltips]="analysisTooltips"
            [statusLabels]="statusLabels"
            [noDocumentSentLabel]="noDocumentSentLabel"
            (toggleStage)="toggleStage(stage.name)"
            (documentSelected)="handleTableAction($event.document, $event.requiredDocument, stage)">
          </app-analysis-stage-section>
        </ng-container>
      </div>
    </div>

    <!-- Footer com ações -->
    <app-analysis-footer-bar
      [metrics]="metrics"
      [finalizeLabel]="finalizeAnalysisLabel"
      [approveAllLabel]="approveAllLabel"
      [isApprovingAll]="isApprovingAll"
      (approveAll)="handleApproveAllPending()"
      (finalize)="finalizeDocumentAnalysis()">
    </app-analysis-footer-bar>
  </ng-container>

  <app-dialog
    [key]="'document-rejection'"
    [action]="'document-rejection'"
    [headerTheme]="'none'"
    [breakpoints]="{
      '960px': '400px',
      '640px': '100vw',
    }"
    [title]="tk.Management.AreYouSureYouWantToReject | t">
  </app-dialog>

  <app-dialog
    [key]="'document-undone'"
    [action]="'document-undone'"
    [headerTheme]="'none'"
    [breakpoints]="{
      '960px': '400px',
      '640px': '100vw',
    }"
    [title]="tk.Management.TheReviewWillBeSavedNSentToCustomer | t">
  </app-dialog>

  <app-dialog
    #finishDialog
    [key]="'document-finish'"
    [action]="'document-finish'"
    [headerTheme]="'none'"
    [breakpoints]="{
      '960px': '400px',
      '640px': '100vw',
    }"
    [title]="tk.Management.AreYouSureYouWantToFinish | t">
    <div class="document-analysis-company__finalize-options">
      <p class="document-analysis-company__finalize-text">
        {{ tk.Management.TheReviewWillBeSavedNSentToCustomer | t }}
      </p>

      <app-checkbox
        data-cy="finalize-send-email-checkbox"
        [checkbox]="sendEmailCheckbox"
        (sendCheckedChange)="onSendEmailOnFinalizeChange($event)">
      </app-checkbox>
    </div>
  </app-dialog>

  <app-dialog
    #unfinishDialog
    [key]="'document-unfinish'"
    [action]="'document-unfinish'"
    [headerTheme]="'none'"
    [breakpoints]="{
      '960px': '400px',
      '640px': '100vw',
    }"
    [title]="tk.Management.ThereAreUnratedFiles | t">
  </app-dialog>

  <app-dialog
    #previewDialog
    data-cy="document-preview-modal"
    [key]="'document-preview'"
    [action]="'document-preview'"
    [headerTheme]="'simple'"
    [showMaximizeButton]="true"
    [hideDefaultFooter]="true"
    [maxWidth]="'95vw'"
    [maxHeight]="'100vh'"
    [breakpoints]="{
      '960px': '400px',
      '640px': '100vw',
    }">
    <ng-template #title>
      <div style="text-align: left">
        <h4>
          <b>
            {{
              onboardingDocumentsTranslationService.getTranslationForDocument(
                selectedDocumentStage?.name!,
                selectedDocumentRequiredDocument?.name!
              )
            }}
          </b>
        </h4>
        <h5>
          {{ this.selectedDocumentAnalysisFile?.fileNameWithoutTimestamp }}
        </h5>
      </div>
    </ng-template>

    <div class="document-analysis-company__modal-content" *ngIf="selectedDocumentAnalysisFile">
      <div class="document-analysis-company__modal-content__preview">
        <app-document-preview [document]="selectedDocumentAnalysisFile"></app-document-preview>
      </div>

      <div class="document-analysis-company__modal-content__notes">
        <label class="form-label">Anotações</label>
        <textarea
          data-cy="document-notes-textarea"
          rows="3"
          placeholder="Anotações"
          class="form-control"
          pTextarea
          [(ngModel)]="notes"></textarea>
      </div>
    </div>

    <ng-template #footer>
      <div class="dialog__footer">
        <app-button
          data-cy="reject-document-btn"
          [attr.data-document-id]="selectedDocumentAnalysisFile?.id"
          [label]="(tk.General.Reject | t) || ''"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="handleDocumentAnalysisAction(selectedDocumentAnalysisFile!, 'reject')">
        </app-button>
        <app-button
          data-cy="approve-document-btn"
          [attr.data-document-id]="selectedDocumentAnalysisFile?.id"
          [label]="(tk.General.Approve | t) || ''"
          [type]="'button'"
          [theme]="'highlight'"
          (sendButtonClick)="handleDocumentAnalysisAction(selectedDocumentAnalysisFile!, 'finish')">
        </app-button>
      </div>
    </ng-template>
  </app-dialog>
</section>
